/* eslint-disable @next/next/no-img-element */
import Axios from 'axios';
import React, { useState } from 'react';
import { BrStates } from '../../../data/misc/states';
import { cepMask } from '../../../utils/masks';
import Select from '../../atoms/Select';
import TextInput from '../../atoms/TextInput';

function Step2({ handleChange, handleBlur, values, setFieldValue, touched, errors }) {
  const [loading, setLoading] = useState(false);

  return (
    <>
      <h4>Dados da loja</h4>
      <TextInput
        placeholder="Nome da loja"
        name="storeName"
        onChange={handleChange}
        value={values.storeName}
        onBlur={handleBlur}
        completed={touched.storeName && !errors.storeName}
        error={touched.storeName && errors.storeName}
      />
      <TextInput
        placeholder="CEP"
        name="storeZipcode"
        onChange={(ev) => {
          if (loading) return;

          ev.target.value = cepMask(ev.target.value);

          const cleanValue = ev.target.value.replace(/[^0-9]/gi, '');

          if (cleanValue.length >= 8) {
            setLoading(true);
            Axios.get(`https://viacep.com.br/ws/${cleanValue}/json/`)
              .then(({ data }) => {
                if (!!data.erro) return;

                setFieldValue('storeCity', data.localidade || '');
                setFieldValue('storeState', data.uf || '');
                setFieldValue('storeDistrict', data.bairro || '');
                setFieldValue('storeAddress', data.logradouro || '');
              })
              .catch((err) => {
                //
              })
              .finally(() => {
                setLoading(false);
              });
          }

          handleChange(ev);
        }}
        value={values.storeZipcode}
        onBlur={handleBlur}
        completed={touched.storeZipcode && !errors.storeZipcode}
        error={touched.storeZipcode && errors.storeZipcode}
      >
        <img src="assets/rastreadores/ic-search.svg" alt="" />
      </TextInput>
      <TextInput
        placeholder="Endereço"
        name="storeAddress"
        onChange={handleChange}
        value={values.storeAddress}
        onBlur={handleBlur}
        completed={touched.storeAddress && !errors.storeAddress}
        error={touched.storeAddress && errors.storeAddress}
      />
      <TextInput
        placeholder="Número"
        name="storeNumber"
        onChange={handleChange}
        value={values.storeNumber}
        onBlur={handleBlur}
        completed={touched.storeNumber && !errors.storeNumber}
        error={touched.storeNumber && errors.storeNumber}
      />
      <TextInput
        placeholder="Complemento"
        name="storeComplement"
        onChange={handleChange}
        value={values.storeComplement}
        onBlur={handleBlur}
        completed={touched.storeComplement && !errors.storeComplement}
        error={touched.storeComplement && errors.storeComplement}
      />
      <TextInput
        placeholder="Bairro"
        name="storeDistrict"
        onChange={handleChange}
        value={values.storeDistrict}
        onBlur={handleBlur}
        completed={touched.storeDistrict && !errors.storeDistrict}
        error={touched.storeDistrict && errors.storeDistrict}
      />
      <TextInput
        placeholder="Cidade"
        name="storeCity"
        onChange={handleChange}
        value={values.storeCity}
        disabled
        onBlur={handleBlur}
        completed={touched.storeCity && !errors.storeCity}
        error={touched.storeCity && errors.storeCity}
      />

      <Select
        disabled
        placeholder="Estado"
        name="storeState"
        value={values.storeState}
        onBlur={handleBlur}
        completed={touched.storeState && !errors.storeState}
        error={touched.storeState && errors.storeState}
        options={BrStates.map((state) => ({
          value: state.sigla,
          text: state.nome,
        }))}
      />
    </>
  );
}

export default Step2;
